var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertiesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.32,
    height: 18,
    viewBox: "0 0 18.32 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34115",
    "data-name": "Group 34115",
    transform: "translate(22749 21784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72246",
    "data-name": "Path 72246",
    d: "M9.416.085a2.821,2.821,0,0,1,3.419,2.05,2.885,2.885,0,0,1,.079.519l0,.165V4.846h.94A2.82,2.82,0,0,1,16.672,7.5l0,.166v8.925h.94a.7.7,0,0,1,.1,1.4l-.1.006H.7a.7.7,0,0,1-.1-1.4l.1-.007h.94V4.228A2.819,2.819,0,0,1,3.617,1.539l.162-.045Zm.342,1.367L4.121,2.861A1.41,1.41,0,0,0,3.054,4.228V16.591h8.456V2.819A1.412,1.412,0,0,0,9.758,1.452m4.1,4.8h-.94V16.591h2.349V7.665a1.409,1.409,0,0,0-1.409-1.409",
    transform: "translate(-22749 -21784)",
    fill: "#4b74be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72247",
    "data-name": "Path 72247",
    d: "M6.968,13.162H8.847a.7.7,0,1,1,0,1.409H6.968a.7.7,0,1,1,0-1.409m0-3.758H8.847a.7.7,0,1,1,0,1.409H6.968a.7.7,0,1,1,0-1.409m0-3.758H8.847a.7.7,0,1,1,0,1.409H6.968a.7.7,0,1,1,0-1.409",
    transform: "translate(-22749.627 -21784.564)",
    fill: "#4b74be"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertiesActive);
export default __webpack_public_path__ + "static/media/PropertiesActive.8ad67bf4a28ad158e4fd6d7f97a7be5f.svg";
export { ForwardRef as ReactComponent };